import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { stringifySync } from '@bingads-webui/safe-json';
import { SurveyDataService } from '@bingads-webui-campaign-react/survey-data-service';

export const SurveyContainer = (props) => {
  const {
    survey,
    logActivity,
    isTestEnv,
    onSurveyRender,
    serverContext,
    tokenInfo,
    lastActiveElement,
    resetActiveElement,
  } = props;

  const Component = useMemo(() => {
    const SurveyComponent = survey.getSurveyComponent();

    return (
      <SurveyComponent
        logActivity={logActivity}
        surveyName={survey.getSurveyName()}
        surveyDataService={SurveyDataService({
          isTestEnv,
          surveyId: survey.getSurveyId(isTestEnv),
          surveyName: survey.getSurveyName(),
          Interface: survey.getSurveyInterface(),
          Product: survey.getSurveyProduct(),
          customParams: survey.getSurveyCustomParams(),
          serverContext,
          tokenInfo,
          isReportingPipelineEnabled: survey.isReportingPipelineEnabled(),
          logActivity,
        })}
        onSurveySubmit={(additionalLogData = {}) => {
          survey.onSurveySubmit();
          resetActiveElement();
          logActivity(`SurveyManager | survey: ${survey.getSurveyName()}, action: submit, additionalLogData: ${stringifySync(additionalLogData)}`);
        }}
        onSurveyDismiss={(additionalLogData = {}) => {
          survey.onSurveyDismiss();
          resetActiveElement();
          logActivity(`SurveyManager | survey: ${survey.getSurveyName()}, action: dismiss, additionalLogData: ${stringifySync(additionalLogData)}`);
        }}
        onSurveyRender={onSurveyRender}
        lastActiveElement={lastActiveElement}
        customParams={survey.getSurveyCustomParams()}
      />
    );
  }, [survey, isTestEnv, serverContext, tokenInfo, logActivity, onSurveyRender, lastActiveElement, resetActiveElement]);

  return Component;
};

SurveyContainer.propTypes = {
  survey: PropTypes.shape({
    getSurveyName: PropTypes.func.isRequired,
    getSurveyId: PropTypes.func.isRequired,
    getSurveyComponent: PropTypes.func.isRequired,
    getSurveyInterface: PropTypes.func.isRequired,
    getSurveyProduct: PropTypes.func.isRequired,
    getSurveyCustomParams: PropTypes.func.isRequired,
    isReportingPipelineEnabled: PropTypes.func.isRequired,
    onSurveyRender: PropTypes.func.isRequired,
    onSurveySubmit: PropTypes.func.isRequired,
    onSurveyDismiss: PropTypes.func.isRequired,
  }).isRequired,
  logActivity: PropTypes.func.isRequired,
  isTestEnv: PropTypes.bool.isRequired,
  onSurveyRender: PropTypes.func.isRequired,
  serverContext: PropTypes.shape({}).isRequired,
  tokenInfo: PropTypes.shape({}),
  lastActiveElement: PropTypes.shape({}).isRequired,
  resetActiveElement: PropTypes.func.isRequired,
};

SurveyContainer.defaultProps = {
  tokenInfo: {},
};
